import logo from "../Assets/images/logo512.png"
function Loader({ loading }) {
    return (
        <>
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(233, 233, 233, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <img
                        src={logo} 
                        alt="Loading..."
                        style={{
                            width: '50px', 
                            height: '50px',
                            animation: 'spin 1.8s linear infinite'  
                        }}
                    />
                </div>
            )} 
            <style>
                {`
                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
                `}
            </style>
        </>
    );
}

export default Loader;
